import './precisa.css'

export default function PorquePrecisa() {
  return (
    <>

      <section id="precisa" data-aos="fade-up" data-aos-duration="1000">
        <div class="container">
              <h2>Porque preciso de...</h2>
          <div class="row">
            <div class="col-lg-6 order-2 order-lg-1" >
              <div class="icon-box mt-5 mt-lg-0" data-aos="fade-right" data-aos-duration="300">
                <i class="bi bi-wifi"></i>
                  <h3>REPETIDOR DE SINAL?</h3>
                  <p>É um equipamento instalado para amplificar a área de alcance do sinal do roteador, para pontos da casa onde a internet não chega, ou tem problemas de lentidão por causa da distância.</p>
              </div>
              <div class="icon-box mt-5" data-aos="fade-right" data-aos-duration="500">
                <i class="bi bi-cash-coin"></i>
                <h3>CLUBE DE DESCONTO?</h3>
                <p>Aplicativo CLUBE NETSIM que é baixado na loja de aplicativos de forma gratuita e garante descontos em mais de 3 mil estabelecimentos e alguns aqui na nossa região águas quentes.</p>
              </div>
              <div class="icon-box mt-5" data-aos="fade-right" data-aos-duration="700">
                <i class="bi bi-app"></i>
                <h3>APP'S STANDARD E PREMIUM?</h3>
                <p>São aplicativos de filmes, música e entretenimentos em geral que são liberados através de um portal de aplicativos onde fornecemos suas credenciais de acesso e você mesmo pode escolher.</p>
              </div>

            </div>
            <div class="image-precisa col-lg-6 order-1 order-lg-2">
            </div>
          </div>

        </div>
      </section>
    </>
  )
}